// extracted by mini-css-extract-plugin
export default {"select":"BybB2UzI"};